<script setup lang="ts">
const title = 'Kebijakan Privasi - Kognisi.id'
const keywords =
  'kebijakan privasi, Kognisi.id, perlindungan data, penggunaan data pribadi, kebijakan data, privasi pengguna'
const description =
  'Baca kebijakan privasi Kognisi.id untuk mengetahui bagaimana kami mengumpulkan, menggunakan, dan melindungi data pribadi Anda saat menggunakan layanan kami.'
const url = 'https://kognisi.id/kebijakan-privasi'

useHead({
  link: [{ rel: 'canonical', href: url }]
})
useSeoMeta({
  title,
  keywords,
  description,
  ogUrl: url,
  ogTitle: title,
  ogDescription: description,
  twitterTitle: title,
  twitterDescription: description,
  robots: 'index, follow'
})

const { isMobile } = useDevice()
const menus = ref<Record<string, any>[]>([
  {
    key: 'perolehan_dan_pengumpulan_data_pengguna',
    label: 'A. Perolehan dan Pengumpulan Data Pengguna'
  },
  {
    key: 'penggunaan_data',
    label: 'B. Penggunaan Data'
  },
  {
    key: 'pengungkapan_data_pengguna',
    label: 'C. Pengungkapan Data Pengguna'
  },
  {
    key: 'cookies',
    label: 'D. Cookies'
  },
  {
    key: 'penyimpanan_dan_penghapusan_informasi',
    label: 'E. Penyimpanan dan Penghapusan Informasi'
  },
  {
    key: 'perubahan_kebijakan_privasi',
    label: 'F. Perubahan Kebijakan Privasi'
  }
])
</script>

<template>
  <div id="kebijakan-privasi">
    <NuxtLayout name="static-page">
      <NuxtLoadingIndicator />
      <LazyModulesStaticPageAtomsSidebar v-if="!isMobile" :menus="menus" />
      <LazyModulesStaticPageMoleculesKebijakanPrivasiContent />
    </NuxtLayout>
  </div>
</template>
